class CartDrawer extends HTMLElement {
  constructor() {
    super({
      name: 'Cart Drawer',
      version: '1.0.0'
    });

    this.gwp = document.querySelector('gwp');
  }

  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.addAnimationStyleClassToContentWrap();
  }

  disconnectedCallback() {
    // Remove classes
    let mainContentWrap = document.querySelector('main-content');
    if (!mainContentWrap) return;
    mainContentWrap.classList.remove('cart-drawer--overlay-right');
    mainContentWrap.classList.remove('cart-drawer--push-right');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add('animate', 'active')

    const mobileMenu = document.querySelector('mobilemenu');
    if (mobileMenu && mobileMenu.classList.contains('mobilemenu--isVisible')) {
      mobileMenu.mobilemenuHide();
    }

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, {once: true});

    this.addActiveClass();
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.removeActiveClass();
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, gwp = false) {
    this.classList.contains('is-empty') && this.classList.remove('is-empty');

    let cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    let cartDrawerInner = cartDrawerEl.querySelector('.drawer__inner');
    if (!cartDrawerInner) return;

    cartDrawerInner.classList.contains('is-empty') && cartDrawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.gwp) {
      this.gwp.init();
    }

    if (!gwp) {
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
    if (window.Nosto) {
      Nosto.reloadCart(["cart-upsell"])
    }
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (!mainCartItems) return;
    mainCartItems.classList.remove('cart__items--disabled');
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'header',
        selector: '#cart-icon-bubble'
      }
    ];
  }


  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getAnimationStyle() {

    let animationStyle = '';

    animationStyle = (this.classList.contains('overlay-right')) ? 'cart-drawer--overlay-right' : animationStyle;
    animationStyle = (this.classList.contains('push-right')) ? 'cart-drawer--push-right' : animationStyle;

    return animationStyle;
  }

  addAnimationStyleClassToContentWrap() {
    let mainContentWrap = document.querySelector('main-content');
    if (!mainContentWrap) return;

    if (this.getAnimationStyle() != '') {
      mainContentWrap.classList.add(this.getAnimationStyle());
    }
  }

  addActiveClass() {
    let mainContentWrap = document.querySelector('main-content');
    if (!mainContentWrap) return;

    mainContentWrap.classList.add('cart-drawer--active');
  }

  removeActiveClass() {
    let mainContentWrap = document.querySelector('main-content');
    if (!mainContentWrap) return;

    mainContentWrap.classList.remove('cart-drawer--active');
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  constructor() {
    super({
      name: ' Cart Drawer Items',
      version: '1.0.0'
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        section: 'header',
        selectors: '#cart-icon-bubble'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);